import React from 'react';
import { PropTypes } from 'prop-types';
import { Paper, Typography } from '@mui/material';

const DashboardSection = ({ children, title }) => (
    <Paper
        elevation={0}
        sx={theme => ({
            ml: 3,
            backgroundColor: theme.palette.grey[100],
            paddingX: 3,
            paddingY: 2,
            '&:not(last-child)': { marginBottom: theme.spacing(4) },
        })}
    >
        <Typography variant="subtitle1" color="primary" sx={{ mb: 3 }}>
            {title}
        </Typography>
        {children}
    </Paper>
);

DashboardSection.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
};

export default DashboardSection;
